import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/quality-assurance/audits-and-remediation")({
  beforeLoad: () => { throw redirect({ to: "/en/services/quality-assurance/integrated-audit-solutions", statusCode: 301 }); },
});
